var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-it-button",staticStyle:{"display":"none"},attrs:{"data-lang":_vm.lang,"data-url":_vm.url,"data-type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }